import * as React from 'react';
import type { Dispatch } from 'react';

import { extractPhoneNumber } from '@/shared/actions/format.builder';
import type { ISubSections } from '@/shared/actions/navigation.service';
import { Icon } from '@/shared/ui/icon/icon';

export interface IMobileMenuTopBarProps {
    phone?: string;
    subsectionSelected: ISubSections | null;
    setSubsectionSelected: Dispatch<React.SetStateAction<ISubSections | null>>;
    handleMenuOpen: (open: boolean) => void;
    mobileMainMenuButtonLabel: string;
    mobileCloseMenuButtonLabel: string;
}

export function MobileMenuTopBar({
    phone,
    subsectionSelected,
    setSubsectionSelected,
    handleMenuOpen,
    mobileMainMenuButtonLabel,
    mobileCloseMenuButtonLabel,
}: IMobileMenuTopBarProps) {
    return (
        <div className='flex w-full items-end justify-end px-9 pt-4 pb-7'>
            <div className='flex h-8 w-full items-center justify-between'>
                {phone &&
                    !subsectionSelected &&
                    (() => {
                        const phoneData = extractPhoneNumber(phone);
                        return (
                            <a className='flex items-center gap-2' href={phoneData.href}>
                                <Icon name='IcCall' />
                                <span className='text-button-md-500'>{phoneData.formatted}</span>
                            </a>
                        );
                    })()}
                {subsectionSelected && (
                    <button
                        className='flex cursor-pointer items-center gap-2'
                        onClick={() => setSubsectionSelected(null)}>
                        <Icon name='IcArrowUp' />
                        <span className='text-button-md-500'>{mobileMainMenuButtonLabel}</span>
                    </button>
                )}
                <button onClick={() => handleMenuOpen(false)} className='flex cursor-pointer items-center gap-2'>
                    <span className='text-button-md-500'>{mobileCloseMenuButtonLabel}</span>
                    <div className='bg-surface-gray-lightest flex size-6 items-center justify-center rounded-full'>
                        <Icon name='IcClose' />
                    </div>
                </button>
            </div>
        </div>
    );
}
